/* Galeries de médias réels — lecture au défilement et visionneuse.

   Autonome : aucune dépendance, aucune bibliothèque. Le script fonctionne
   partout où la section « médias » est posée, fiche produit comprise.

   Deux comportements :
     1. une vidéo se lance quand elle est majoritairement visible, en muet,
        se met en pause en sortant de l'écran, et une seule joue à la fois ;
     2. les photos s'ouvrent dans une visionneuse plein écran, au clic, au
        clavier et au toucher.

   Respecte prefers-reduced-motion et le mode économie de données : dans ces
   cas la vidéo reste sur son image d'affiche avec un bouton de lecture.
*/
(function () {
  'use strict';

  var sobre = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var economie = !!(navigator.connection && navigator.connection.saveData);
  var autoplayPermis = !sobre && !economie;

  /* ================= 1. Vidéos ================= */

  var enCours = null; // une seule vidéo à la fois

  function jouer(v) {
    if (enCours && enCours !== v) { try { enCours.pause(); } catch (e) {} }
    enCours = v;
    v.muted = true; // jamais de son au démarrage automatique
    // Avec preload="none" la vidéo n'a aucune donnée : play() échoue en
    // silence. On charge d'abord, puis on relance dès que c'est jouable.
    if (v.readyState < 2) {
      v.preload = 'auto';
      v.addEventListener('canplay', function relancer() {
        v.removeEventListener('canplay', relancer);
        if (enCours === v) { var q = v.play(); if (q && q.catch) q.catch(function () {}); }
      });
      try { v.load(); } catch (e) {}
      return;
    }
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function preparer(carte) {
    var v = carte.querySelector('video');
    if (!v) return;
    v.muted = true;
    v.setAttribute('playsinline', '');
    v.removeAttribute('controls'); // habillage maison, accessible

    var lecture = carte.querySelector('[data-tm-play]');
    var son = carte.querySelector('[data-tm-sound]');

    function majEtat() {
      if (!lecture) return;
      var joue = !v.paused && !v.ended;
      lecture.setAttribute('aria-label', joue ? 'Mettre en pause' : 'Lire la vidéo');
      carte.classList.toggle('is-playing', joue);
    }
    v.addEventListener('play', majEtat);
    v.addEventListener('pause', majEtat);

    if (lecture) {
      lecture.addEventListener('click', function () {
        if (v.paused) jouer(v); else v.pause();
      });
    }
    if (son) {
      son.addEventListener('click', function () {
        v.muted = !v.muted;
        son.setAttribute('aria-pressed', String(!v.muted));
        son.setAttribute('aria-label', v.muted ? 'Activer le son' : 'Couper le son');
        carte.classList.toggle('is-unmuted', !v.muted);
      });
    }

    if (!autoplayPermis) { carte.classList.add('is-manuel'); majEtat(); return; }

    // 55 % visible : on lance. Moins de 25 % : on met en pause.
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        // Dès qu'elle entre dans le champ, on autorise le préchargement.
        if (e.intersectionRatio > 0 && v.preload === 'none') v.preload = 'metadata';
        if (e.intersectionRatio >= 0.55) {
          if (v.paused) jouer(v);
        } else if (e.intersectionRatio < 0.25) {
          if (!v.paused) { v.pause(); if (enCours === v) enCours = null; }
        }
      });
    }, { threshold: [0, 0.25, 0.55, 0.8] });
    io.observe(carte);
    majEtat();
  }

  /* ================= 2. Visionneuse ================= */

  var vue = null;
  var galerieActive = [];
  var indexActif = 0;
  var dernierFocus = null;

  function construire() {
    if (vue) return vue;
    vue = document.createElement('div');
    vue.className = 'tm-lightbox';
    vue.setAttribute('role', 'dialog');
    vue.setAttribute('aria-modal', 'true');
    vue.setAttribute('aria-label', 'Photo agrandie');
    vue.hidden = true;
    vue.innerHTML =
      '<div class="tm-lightbox__fond" data-tm-close></div>' +
      '<button class="tm-lightbox__fermer" type="button" data-tm-close aria-label="Fermer">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button>' +
      '<button class="tm-lightbox__nav tm-lightbox__nav--prev" type="button" data-tm-prev aria-label="Photo précédente">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>' +
      '</button>' +
      '<figure class="tm-lightbox__figure"><img alt=""><figcaption></figcaption></figure>' +
      '<button class="tm-lightbox__nav tm-lightbox__nav--next" type="button" data-tm-next aria-label="Photo suivante">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>' +
      '</button>';
    document.body.appendChild(vue);

    vue.addEventListener('click', function (e) {
      if (e.target.closest('[data-tm-close]')) fermer();
      else if (e.target.closest('[data-tm-prev]')) aller(-1);
      else if (e.target.closest('[data-tm-next]')) aller(1);
    });

    // Balayage au doigt.
    var x0 = null;
    vue.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    vue.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) aller(dx < 0 ? 1 : -1);
      x0 = null;
    }, { passive: true });

    return vue;
  }

  function afficher() {
    var m = galerieActive[indexActif];
    var img = vue.querySelector('img');
    var cap = vue.querySelector('figcaption');
    img.src = m.plein;
    img.alt = m.alt || '';
    cap.textContent = m.legende || '';
    cap.hidden = !m.legende;
    var multi = galerieActive.length > 1;
    vue.querySelector('[data-tm-prev]').hidden = !multi;
    vue.querySelector('[data-tm-next]').hidden = !multi;
  }

  function aller(pas) {
    if (galerieActive.length < 2) return;
    indexActif = (indexActif + pas + galerieActive.length) % galerieActive.length;
    afficher();
  }

  function ouvrir(galerie, index, source) {
    construire();
    galerieActive = galerie;
    indexActif = index;
    dernierFocus = source || document.activeElement;
    afficher();
    vue.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    // Le focus doit attendre que l'élément soit réellement affiché.
    requestAnimationFrame(function () { vue.querySelector('.tm-lightbox__fermer').focus(); });
    document.addEventListener('keydown', clavier);
  }

  function fermer() {
    if (!vue || vue.hidden) return;
    vue.hidden = true;
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', clavier);
    if (dernierFocus && dernierFocus.focus) dernierFocus.focus();
  }

  function clavier(e) {
    if (e.key === 'Escape') { e.preventDefault(); fermer(); }
    else if (e.key === 'ArrowLeft') aller(-1);
    else if (e.key === 'ArrowRight') aller(1);
    else if (e.key === 'Tab') {
      // Le focus reste dans la visionneuse.
      var cibles = [].slice.call(vue.querySelectorAll('button:not([hidden])'));
      if (!cibles.length) return;
      var premier = cibles[0], dernier = cibles[cibles.length - 1];
      if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
      else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
    }
  }

  /* ================= 3. Mise en route ================= */

  document.querySelectorAll('[data-tm-galerie]').forEach(function (sec) {
    var cartes = [].slice.call(sec.querySelectorAll('[data-tm-media]'));
    var photos = cartes.filter(function (c) { return c.hasAttribute('data-tm-plein'); });
    var liste = photos.map(function (c) {
      return { plein: c.getAttribute('data-tm-plein'), alt: c.getAttribute('data-tm-alt'), legende: c.getAttribute('data-tm-legende') };
    });

    cartes.forEach(function (carte) {
      if (carte.querySelector('video')) { preparer(carte); return; }
      if (!carte.hasAttribute('data-tm-plein')) return;
      var i = photos.indexOf(carte);
      var bouton = carte.querySelector('[data-tm-zoom]');
      if (!bouton) return;
      bouton.addEventListener('click', function () { ouvrir(liste, i, bouton); });
    });
  });
})();
